
import { Link } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
const Footer = () => {
    const footeren = {
        "1": "Company",
        "2": "Home",
        "3": "About Us",
        "4": "Our Products",
        "5": "Contact Us",
        "6": "Important",
        "7": "FAQ",
        "8": "Privacy Policy",
        "9": "Shipping policy",
        "10": "Terms & Conditions",
        "11": "Exchange & Return Policy",
        "12": "Cancellation & Refund",
        "13": "Quick Link",
        "14": "Login",
        "15": "Official Info",
        "16": "Location",
        "17": "No 3m-219, Ambika Corner, Kasturi Nagar, Bengaluru-560043",
        "18": "Email",
        "19": "Phone",
        "20": "TerraClenz. All Rights Reserved",
         "21": "Designed by Excerpt Technologies Pvt Ltd",
         "22": "Secure Online Payment",
        "23": "All transactions are processed securely through",
        "24": "100% Safe & Encrypted Checkout"
    }
    const footerta = {
        "1": "நிறுவனம்",
        "2": "முகப்பு",
        "3": "எங்களை பற்றி",
        "4": "எங்கள் தயாரிப்புகள்",
        "5": "தொடர்புக்கு",
        "6": "முக்கியமானவை",
        "7": "கேள்விகள் & பதில்கள் (FAQ)",
        "8": "தனியுரிமைக் கொள்கை",
        "9": "ஷிப்பிங் கொள்கை",
        "10": "விதிமுறைகள் & நிபந்தனைகள்",
        "11": "மாற்றம் & திரும்பப் பெறும் கொள்கை",
        "12": "ரத்தாக்கல் & மீள்பணம்",
        "13": "விரைவு இணைப்பு",
        "14": "உள்நுழைவு",
        "15": "அதிகாரப்பூர்வ தகவல்",
        "16": "இருப்பிடம்",
        "17": "230, 2B கிராஸ், கஸ்தூரி நகர், பெங்களூரு - 560043",
        "18": "மின்னஞ்சல்",
        "19": "தொலைபேசி",
        "20": "டெர்ராக்லென்ஸ். அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை",
        "21": "வடிவமைத்தது Excerpt Technologies Pvt Ltd",
        "22": "பாதுகாப்பான ஆன்லைன் கட்டணம்",
        "23": "அனைத்து பரிவர்த்தனைகளும் பாதுகாப்பாக செயலாக்கப்படுகின்றன",
        "24": "100% பாதுகாப்பான & குறியாக்கப்பட்ட பரிமாற்றம்"
    }
    const footerka = {
        "1": "ಕಂಪನಿ",
        "2": "ಪ್ರಥಮ ಪುಟ",
        "3": "ನಮ್ಮ ಬಗ್ಗೆ",
        "4": "ನಮ್ಮ ಉತ್ಪನ್ನಗಳು",
        "5": "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",
        "6": "ಪ್ರಮುಖ",
        "7": "ಪದೇ ಪದೇ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು",
        "8": "ಗೌಪ್ಯತಾ ನೀತಿ",
        "9": "ಸಾಗಣೆ ನೀತಿ",
        "10": "ನಿಯಮ ಮತ್ತು ಶರತ್ತುಗಳು",
        "11": "ವಿನಿಮಯ ಮತ್ತು ವಾಪಸಾತಿ ನೀತಿ",
        "12": "ರದ್ದತಿ ಮತ್ತು ಮರುಪಾವತಿ",
        "13": "ತ್ವರಿತ ಲಿಂಕ್",
        "14": "ಲಾಗಿನ್ ಮಾಡಿ",
        "15": "ಅಧಿಕೃತ ಮಾಹಿತಿ",
        "16": "ಸ್ಥಳ",
        "17": "230, 2ಬಿ ಕ್ರಾಸ್, ಕಸ್ತೂರಿ ನಗರ, ಬೆಂಗಳೂರು - 560043",
        "18": "ಇಮೇಲ್",
        "19": "ದೂರವಾಣಿ",
        "20": "ಟೆರ್ರಾಕ್ಲೆನ್ಜ್ . ಎಲ್ಲಾ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.",
          "21": "ಡಿಸೈನ್ ಮಾಡಿದವರು Excerpt Technologies Pvt Ltd",
            "22": "ಸುರಕ್ಷಿತ ಆನ್ಲೈನ್ ಪಾವತಿ",
        "23": "ಎಲ್ಲಾ ವ್ಯವಹಾರಗಳು ಸುರಕ್ಷಿತವಾಗಿ ಪ್ರಕ್ರಿಯೆಯಾಗುತ್ತವೆ",
        "24": "100% ಸುರಕ್ಷಿತ ಮತ್ತು ಎನ್ಕ್ರಿಪ್ಟ್ ಚೆಕ್ಔಟ್"
    }
    

    const footerte = {
        "1": "కంపెనీ",
        "2": "హోం",
        "3": "మా గురించి",
        "4": "మా ఉత్పత్తులు",
        "5": "మమ్మల్ని సంప్రదించండి",
        "6": "ముఖ్యం",
        "7": "తరచుగా అడిగే ప్రశ్నలు",
        "8": "గోప్యతా విధానం",
        "9": "రవాణా విధానం",
        "10": "నిబంధనలు & షరతులు",
        "11": "మార్పిడి & రీఫండ్ విధానం",
        "12": "రద్దు & తిరిగి చెల్లింపు",
        "13": "త్వరిత లింక్",
        "14": "లాగిన్",
        "15": "అధికారిక సమాచారం",
        "16": "స్థానం",
        "17": "230, 2బీ క్రాస్, కస్తూరి నగర్, బెంగళూరు - 560043",
        "18": "ఇమెయిల్",
        "19": "ఫోన్",
        "20": "టెర్రాక్లెన్జ్. అన్ని హక్కులు కలదిగా ఉన్నాయి.",
         "21": "డిజైన్ చేసినది Excerpt Technologies Pvt Ltd",
          "22": "సురక్షిత ఆన్‌లైన్ చెల్లింపు",
        "23": "అన్ని లావాదేవీలు సురక్షితంగా ప్రాసెస్ చేయబడతాయి",
        "24": "100% సురక్షిత & ఎన్‌క్రిప్ట్ చేయబడిన చెక్ఔట్"
    }
    const footerhi ={
        "1": "कंपनी",
        "2": "होम",
        "3": "हमारे बारे में",
        "4": "हमारे उत्पाद",
        "5": "संपर्क करें",
        "6": "महत्वपूर्ण",
        "7": "सामान्य प्रश्न (FAQ)",
        "8": "गोपनीयता नीति",
        "9": "शिपिंग नीति",
        "10": "नियम और शर्तें",
        "11": "विनिमय और वापसी नीति",
        "12": "रद्दीकरण और धनवापसी",
        "13": "त्वरित लिंक",
        "14": "लॉगिन",
        "15": "आधिकारिक जानकारी",
        "16": "स्थान",
        "17": "230, 2बी क्रॉस, कस्तूरी नगर, बेंगलुरु - 560043",
        "18": "ईमेल",
        "19": "फोन",
        "20": "टेराक्लेंज। सभी अधिकार सुरक्षित",
         "21": "डिज़ाइन किया गया Excerpt Technologies Pvt Ltd",
          "22": "सुरक्षित ऑनलाइन भुगतान",
        "23": "सभी लेनदेन सुरक्षित रूप से संसाधित किए जाते हैं",
        "24": "100% सुरक्षित और एन्क्रिप्टेड चेकआउट"
    }
    
    const [footer, setHomeen] = useState(footeren)

    useEffect(() => {
        const storedLanguage = localStorage.getItem("selectedLanguage") || "en";
    switch (storedLanguage) {
        case "kn":
            setHomeen(footerka);
            break;
        case "te":
            setHomeen(footerte);
            break;
        case "ta":
            setHomeen(footerta);
            break;
            case "hi":
            setHomeen(footerhi);
            break;
        default:
                setHomeen(footeren);
    }

}, []);
    return (
        <>
            <footer class="footer-wrap">
                <div class="container" style={{maxWidth:"100%"}}>
                   <div className="row pt-20 gy-4">
    {/* Logo Section */}
    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
        <div className="footer-widget">
            <a href="/" className="footer-logo">
                <img src="assets/img/Logo23-02.gif" alt="Image" style={{ height: "30vh" }} />
            </a>
        </div>
    </div>

    {/* Company Links */}
    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12" style={{ marginRight: "-220px" }}>
        <div className="footer-widget">
            <h3 className="footer-widget-title" style={{ textAlign: "left" }}>{footer["1"]}</h3>
            <ul className="footer-menu list-style" style={{ textAlign: "left", padding: 0 }}>
                <li><Link to="/"><i className="ri-arrow-right-s-line"></i>{footer["2"]}</Link></li>
                <li><Link to="/aboutus"><i className="ri-arrow-right-s-line"></i>{footer["3"]}</Link></li>
                <li><Link to="/products"><i className="ri-arrow-right-s-line"></i>{footer["4"]}</Link></li>
                <li><Link to="/contactus"><i className="ri-arrow-right-s-line"></i>{footer["5"]}</Link></li>
            </ul>
        </div>
    </div>

    {/* Razorpay Payment Section */}
    {/* <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12"> */}
    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mx-auto">

        <div className="footer-widget">
            <h3 className="footer-widget-title">{footer["22"]}</h3>
            <p style={{ color: "#000", marginBottom: "5px" }}>{footer["23"]}</p>
            <img src="assets/img/razropay2.png" alt="Razorpay" style={{ width: "120px", marginBottom: "5px" }} />
            <p style={{ fontSize: "14px", color: "#000" }}>{footer["24"]}</p>
        </div>
    </div>

    {/* Contact Info */}
    {/* <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12" > */}
   <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 ms-auto">


        <div className="footer-widget">
            <h3 className="footer-widget-title" style={{ textAlign: "left" }}>{footer["15"]}</h3>
            <ul className="contact-info list-style" style={{ textAlign: "left", padding: 0 }}>
                <li><i className="flaticon-map" style={{ color: "#000" }}></i><p style={{ width: "80%", color: "black" }}>{footer["17"]}</p></li>
                <li><i className="flaticon-email-1" style={{ color: "#000" }}></i><a style={{ color: "#000" }} href="mailto:Support@terraclenz.com">Support@terraclenz.com</a></li>
                <li><i className="flaticon-phone-call-1" style={{ color: "#000" }}></i><a style={{ color: "#000" }} href="tel:+917022519222">+91 7022519222</a></li>
            </ul>
        </div>
    </div>
</div>

                </div>
                {/* <p class="inlinehere" style={{ color:"#000"}}><i class="ri-copyright-line"></i> {footer["20"].split(" ")[0]}<span class="here" style={{color:"black"}}>TM</span>{footer["20"].split(" ").slice(1).join(" ")}</p> */}
                 <p className="inlinehere" style={{ color: "#000" }}>
    <i className="ri-copyright-line"></i>
    {footer["20"].split(" ")[0]}<span className="here" style={{ color: "black" }}>TM</span>
    {footer["20"].split(" ").slice(1).join(" ")}
    {" | "}
   <Link
  to="https://excerptech.com/"
  target="_blank"
  rel="noopener noreferrer"
  style={{ color: "#000", textDecoration: "none", fontWeight: "500" }}
>
  {footer["21"]}
</Link>

</p>

            </footer>
        </>
    );
};
export default Footer